export default __webpack_public_path__ + "static/media/fpb20004.4fe5b894.png";